export default __webpack_public_path__ + "static/media/divine.851e0b63.png";